export function _alphaNumvalidateInput(input) {
    // Regular expression to allow only alphabets (lowercase/uppercase), numbers, and underscores
    const regex = /^[a-zA-Z0-9_]+$/;
    
    // Test the input against the regex
    return regex.test(input);
}